import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import like from 'four-nets/icons/svg/icon_like.svg';

import Button from '../footer/buttons/button/button';
import defaultStyles from './like-button.scss';

export interface Props {
    styles: typeof defaultStyles;
    onClick: () => any;
    onTouchEnd?: () => any;
    isLikedByViewer?: boolean;
    likesCount?: number | null;
    inFeed?: boolean;
}

class LikeButton extends React.PureComponent<Props> {
    render() {
        const { styles, isLikedByViewer, onClick, onTouchEnd, likesCount, inFeed } = this.props;

        return inFeed ? (
            <Button style={{ button: styles.feedButton }} onClick={onClick} onTouchEnd={onTouchEnd}>
                {!likesCount ? <SVGIcon style={{ image: styles.icon }} src={like} /> : null}
                {isLikedByViewer ? <FormattedMessage id='UNLIKE' /> : <FormattedMessage id='LIKE' />}
            </Button>
        ) : (
            <Button style={{ button: styles.button }} onClick={onClick} onTouchEnd={onTouchEnd}>
                {!likesCount ? <SVGIcon style={{ image: styles.icon }} src={like} /> : null}
                {isLikedByViewer ? <FormattedMessage id='UNLIKE' /> : <FormattedMessage id='LIKE' />}
            </Button>
        );
    }
}

export default Styled(defaultStyles)(LikeButton);
